var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTimeline01 = function SvgTimeline01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "timeline-01_svg2__a",
    x1: 64.24,
    x2: 225.93,
    y1: 232.62,
    y2: 78.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#timeline-01_svg2__a",
    id: "timeline-01_svg2__b",
    x1: 19.2,
    x2: 180.9,
    y1: 185.33,
    y2: 31.35
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#timeline-01_svg2__a",
    id: "timeline-01_svg2__c",
    x1: -1.5,
    x2: 160.19,
    y1: 163.58,
    y2: 9.61
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#timeline-01_svg2__a",
    id: "timeline-01_svg2__d",
    x1: 20.72,
    x2: 182.42,
    y1: 186.92,
    y2: 32.94
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#timeline-01_svg2__a",
    id: "timeline-01_svg2__e",
    x1: 42.82,
    x2: 204.52,
    y1: 210.13,
    y2: 56.15
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#timeline-01_svg2__a",
    id: "timeline-01_svg2__f",
    x1: 19.91,
    x2: 181.61,
    y1: 186.07,
    y2: 32.1
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#timeline-01_svg2__a",
    id: "timeline-01_svg2__g",
    x1: 42.14,
    x2: 203.83,
    y1: 209.41,
    y2: 55.43
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M158.86 138.6H132.7c-1.81 0-3.29 1.47-3.29 3.29v26.16c0 1.81 1.47 3.29 3.29 3.29h26.16c1.81 0 3.29-1.47 3.29-3.29v-26.16c0-1.81-1.47-3.29-3.29-3.29m-3.28 26.17h-19.59v-19.59h19.59z",
    style: {
      fill: "url(#timeline-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.03 18.56h-5.48v-6.04c0-7.1-5.78-12.88-12.88-12.88h-3.95c-7.1 0-12.88 5.78-12.88 12.88v6.04H61.41v-6.04c0-7.1-5.78-12.88-12.88-12.88h-3.95c-7.1 0-12.88 5.78-12.88 12.88v6.04h-5.11C11.55 18.56-.69 30.79-.69 45.84v126.42c0 15.04 12.24 27.28 27.28 27.28h145.44c15.04 0 27.28-12.24 27.28-27.28V45.84c0-15.04-12.24-27.28-27.28-27.28m-28.63-6.04c0-3.48 2.83-6.3 6.3-6.3h3.96c3.48 0 6.3 2.83 6.3 6.3v20.56c0 3.48-2.83 6.3-6.3 6.3h-3.96c-3.48 0-6.3-2.83-6.3-6.3zm-105.14 0c0-3.48 2.83-6.3 6.3-6.3h3.96c3.48 0 6.3 2.83 6.3 6.3v20.56c0 3.48-2.83 6.3-6.3 6.3h-3.96c-3.48 0-6.3-2.83-6.3-6.3zm133.77 180.45H26.58c-11.42 0-20.71-9.29-20.71-20.71V79.29h186.86v92.96h.01c0 11.43-9.29 20.72-20.71 20.72m20.73-120.24H5.88V45.84c0-11.42 9.29-20.71 20.71-20.71h5.11v7.94c0 7.1 5.78 12.88 12.88 12.88h3.96c7.1 0 12.88-5.78 12.88-12.88v-7.94h75.43v7.94c0 7.1 5.78 12.88 12.88 12.88h3.96c7.1 0 12.88-5.78 12.88-12.88v-7.94h5.48c11.42 0 20.71 9.29 20.71 20.71z",
    style: {
      fill: "url(#timeline-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.66 95.72H39.5c-1.81 0-3.29 1.47-3.29 3.29v26.16c0 1.81 1.47 3.29 3.29 3.29h26.16c1.81 0 3.29-1.47 3.29-3.29V99.01c0-1.81-1.47-3.29-3.29-3.29m-3.28 26.17H42.79V102.3h19.59z",
    style: {
      fill: "url(#timeline-01_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.39 95.72H86.23c-1.81 0-3.29 1.47-3.29 3.29v26.16c0 1.81 1.47 3.29 3.29 3.29h26.16c1.81 0 3.29-1.47 3.29-3.29V99.01c0-1.81-1.47-3.29-3.29-3.29m-3.29 26.17H89.51V102.3h19.59z",
    style: {
      fill: "url(#timeline-01_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.86 95.72H132.7c-1.81 0-3.29 1.47-3.29 3.29v26.16c0 1.81 1.47 3.29 3.29 3.29h26.16c1.81 0 3.29-1.47 3.29-3.29V99.01c0-1.81-1.47-3.29-3.29-3.29m-3.28 26.17h-19.59V102.3h19.59z",
    style: {
      fill: "url(#timeline-01_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.66 138.6H39.5c-1.81 0-3.29 1.47-3.29 3.29v26.16c0 1.81 1.47 3.29 3.29 3.29h26.16c1.81 0 3.29-1.47 3.29-3.29v-26.16c0-1.81-1.47-3.29-3.29-3.29m-3.28 26.17H42.79v-19.59h19.59z",
    style: {
      fill: "url(#timeline-01_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.39 138.6H86.23c-1.81 0-3.29 1.47-3.29 3.29v26.16c0 1.81 1.47 3.29 3.29 3.29h26.16c1.81 0 3.29-1.47 3.29-3.29v-26.16c0-1.81-1.47-3.29-3.29-3.29m-3.29 26.17H89.51v-19.59h19.59z",
    style: {
      fill: "url(#timeline-01_svg2__g)"
    }
  }));
};
export default SvgTimeline01;